import { Card } from "antd";
import React from "react";
import LinkIcon from "../activityCenter/icons/LinkIcon";
import useLang from "../../../hooks/useLang";

const SuggestedAction = ({ suggestedActionItemClick }) => {
  const [lang] = useLang();

  return (
    <Card size="small" type="inner" title="Suggested action item" className="!rounded-lg" bordered>
      <div
        onClick={suggestedActionItemClick}
        className="flex items-center gap-2 cursor-pointer py-1"
      >
        <LinkIcon />
        <span className="text-[#1677FF] text-sm">{lang.sendTextMessage}</span>
      </div>
    </Card>
  );
};

export default SuggestedAction;
